import axios from 'axios';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = {
  // Products
  getProducts: () => axios.get(`${API_URL}/products`),
  getProduct: (id) => axios.get(`${API_URL}/products/${id}`),
  getAddons: () => axios.get(`${API_URL}/addons`),
  getLegalDocuments: () => axios.get(`${API_URL}/legal-documents`),
  
  // Orders
  createOrder: (data) => axios.post(`${API_URL}/orders`, data),
  getOrders: (status) => axios.get(`${API_URL}/orders`, { params: { status } }),
  getOrder: (id) => axios.get(`${API_URL}/orders/${id}`),
  updateOrder: (id, data) => axios.put(`${API_URL}/orders/${id}`, data),
  sendOrderEmail: (id) => axios.post(`${API_URL}/orders/${id}/send-email`),
  cancelOrder: (id) => axios.post(`${API_URL}/orders/${id}/cancel`),
  exportOrdersCSV: () => axios.get(`${API_URL}/orders/export/csv`, { responseType: 'blob' }),
  downloadVorvertraglicheInfo: (orderId) => axios.get(`${API_URL}/orders/${orderId}/vorvertragliche-info`, { responseType: 'blob' }),
  downloadOrderCsv: (orderId) => axios.get(`${API_URL}/orders/${orderId}/export-csv`, { responseType: 'blob' }),
  downloadContractPdf: (orderId) => axios.get(`${API_URL}/orders/${orderId}/contract-pdf`, { responseType: 'blob' }),
  getVorvertraglicheInfoUrl: (orderId) => `${API_URL}/orders/${orderId}/vorvertragliche-info`,
  getVorvertraglicheInfoPublicUrl: (token) => `${API_URL}/confirm/${token}/vorvertragliche-info`,
  
  // Product Flyer
  downloadProductFlyer: () => axios.get(`${API_URL}/product-flyer`, { responseType: 'blob' }),
  
  // Confirmation (public)
  getConfirmationInfo: (token) => axios.get(`${API_URL}/confirm/${token}`),
  confirmOrder: (token) => axios.post(`${API_URL}/confirm/${token}`),
  
  // Users (admin)
  getUsers: () => axios.get(`${API_URL}/users`),
  createUser: (data) => axios.post(`${API_URL}/auth/register`, data),
  updateUser: (id, data) => axios.put(`${API_URL}/users/${id}`, data),
  deleteUser: (id) => axios.delete(`${API_URL}/users/${id}`),
  
  // Commissions
  getCommissions: () => axios.get(`${API_URL}/commissions`),
  setCommission: (data) => axios.post(`${API_URL}/commissions`, data),
  getCommissionsOverview: (params) => axios.get(`${API_URL}/commissions/overview`, { params }),
  
  // Stats
  getDashboardStats: () => axios.get(`${API_URL}/stats/dashboard`),
  
  // Init
  initAdmin: () => axios.post(`${API_URL}/init-admin`),
};

export default api;
